module.exports = require("././src/uncompressed/TweenMax.js");


//////////////////
// WEBPACK FOOTER
// gsap (bower component)
// module id = 25
// module chunks = 2